
      import '@folkjs/labs/standalone/folk-map';
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-event-propagator';
      import '@folkjs/labs/standalone/folk-spreadsheet';

      window.round = (value) => Math.round(value * 1e4) / 1e4;
    